import OnboardFamilyStatusContainer from './components/OnboardFamilyStatusContainer';

export default OnboardFamilyStatusContainer;
